export const FETCH_PRODUCT_DETAIL_REQUEST=`FETCH_PRODUCT_DETAIL_REQUEST`;
export const FETCH_PRODUCT_DETAIL_SUCCESS=`FETCH_PRODUCT_DETAIL_SUCCESS`;
export const FETCH_PRODUCT_DETAIL_ERROR=`FETCH_PRODUCT_DETAIL_ERROR`;
